import { useContentDetection } from "./../composables/utilities.js";
/**
 * Validation rule by field (copy of php)
 * @returns {{String|null}} Code error
 */
export function useValidation() {
  return {
    username: (value) => {
      if (value.length < 2 || value.length > 30) {
        return "len_range";
      }
      if (!/.*[a-zàâäéèêëîïôöùûüÿç].*[a-zàâäéèêëîïôöùûüÿç].*/i.test(value)) {
        return "username_format";
      }
      return null;
    },

    place: (value) => {
      if (value.length < 3 && value) {
        return "len_min";
      }
      if (value.length > 150) {
        return "len_max";
      }

      const result = useContentDetection(value);

      if (
        result.emails.length > 0 ||
        result.phones.length > 0 ||
        result.urls.length > 0
      ) {
        return "content_not_allowed";
      }

      return null;
    },

    exh_max_count: (value) => {
      if (value <= 0) {
        return "num_min";
      }
      return null;
    },

    name: (value) => {
      if (value.length > 80) {
        return "len_max";
      }
      return null;
    },

    email: (value) => {
      if (
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value,
        )
      ) {
        return "is_email";
      }
      if (value.length > 255) {
        return "len_max";
      }
    },

    title: (value) => {
      if (value.length < 4) {
        return "len_min";
      }
      if (value.length > 80) {
        return "len_max";
      }
      return null;
    },

    password: (value) => {
      if (
        /[\xA0\xAD\u{2000}-\u{200F}\u{2028}-\u{202F}\u{205F}-\u{206F}]/u.test(
          value,
        )
      ) {
        return "special_space";
      }

      if (/\s/.test(value)) {
        return "whitespace";
      }

      if (!/(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,64}/.test(value)) {
        return "password_format";
      }

      return null;
    },

    phone: (value) => {
      if (!/^[0-9 ]*$/.test(value)) {
        return "is_phone";
      }
      return null;
    },

    video: (value) => {
      const pattern =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]+)|youtube\.com\/shorts\/([a-zA-Z0-9_-]+)|youtu\.be\/([a-zA-Z0-9_-]+))/m;

      const match = value.match(pattern);
      if (!match) {
        return "invalid_url";
      }

      return null;
    },

    website: (value) => {
      if (
        !/^(?:https?:\/\/)(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/m.test(
          value,
        )
      ) {
        return "is_url";
      }
      return null;
    },
    description: (value) => {
      const result = useContentDetection(value);

      if (
        result.emails.length > 0 ||
        result.phones.length > 0 ||
        result.urls.length > 0
      ) {
        return "content_not_allowed";
      }

      return null;
    },
    price: (value) => {
      const result = useContentDetection(value);

      if (
        result.emails.length > 0 ||
        result.phones.length > 0 ||
        result.urls.length > 0
      ) {
        return "content_not_allowed";
      }

      return null;
    },
    exh_info: (value) => {
      const result = useContentDetection(value);

      if (
        result.emails.length > 0 ||
        result.phones.length > 0 ||
        result.urls.length > 0
      ) {
        return "content_not_allowed";
      }

      return null;
    },
    schedule: (value) => {
      const result = useContentDetection(value);

      if (
        result.emails.length > 0 ||
        result.phones.length > 0 ||
        result.urls.length > 0
      ) {
        return "content_not_allowed";
      }

      return null;
    },
  };
}
